import { render, staticRenderFns } from "./HomeworkItem.vue?vue&type=template&id=24e1bdae&scoped=true"
import script from "./HomeworkItem.vue?vue&type=script&lang=ts"
export * from "./HomeworkItem.vue?vue&type=script&lang=ts"
import style0 from "./HomeworkItem.vue?vue&type=style&index=0&id=24e1bdae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1bdae",
  null
  
)

export default component.exports